import { useState, useRef } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { apiPost } from "@/config";

const ImageUploadField = ({ id, label, hint, value, onChange, testId }) => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");
  const fileRef = useRef(null);

  const handleFileSelect = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setError("");
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const { data } = await apiPost("/upload-image", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(data.url);
    } catch (err) {
      setError(err.response?.data?.detail || "Upload failed");
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  return (
    <div className="space-y-2">
      <Label htmlFor={id} className="text-slate-300">{label}</Label>
      <div className="flex gap-2">
        <Input
          id={id}
          data-testid={testId || `article-${id}-input`}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="https://example.com/image.jpg"
          className="bg-slate-800 border-slate-600 text-white placeholder:text-slate-500 flex-1"
        />
        <input ref={fileRef} type="file" accept="image/*" onChange={handleFileSelect} className="hidden" />
        <Button
          type="button"
          data-testid={`upload-${id}-button`}
          onClick={() => fileRef.current?.click()}
          disabled={uploading}
          variant="outline"
          className="border-slate-600 text-slate-300 hover:bg-slate-800 shrink-0"
        >
          {uploading ? (
            <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" /><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" /></svg>
          ) : (
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" /></svg>
          )}
        </Button>
      </div>
      {value && (
        <img src={value} alt="Preview" className="w-20 h-20 object-cover rounded border border-slate-700 mt-1" />
      )}
      {error && <p className="text-red-400 text-xs">{error}</p>}
      {hint && <p className="text-slate-500 text-xs">{hint}</p>}
    </div>
  );
};

export default ImageUploadField;
